import { g as n } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as s, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconThumbsDownFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], h = ["id"];
function p(e, t, r, _, g, i) {
  return d(), s("svg", {
    "aria-label": r.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--thumbs-down-filled"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Thumbs Down Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M5.995 11.438a.438.438 0 0 0 .396-.242l1.671-3.338V.722a.437.437 0 0 0-.337-.16H3.25a1.438 1.438 0 0 0-1.38 1.036l-1.165 4a1.438 1.438 0 0 0 1.38 1.84h2.359l-.369 1.517a2.002 2.002 0 0 0 1.92 2.482Zm2.942-4.005V.567A.441.441 0 0 1 9 .563h1A1.437 1.437 0 0 1 11.438 2v4A1.438 1.438 0 0 1 10 7.438H9a.441.441 0 0 1-.063-.005Z" }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          transform: "rotate(180 6 6)",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, h)
    ])
  ], 10, c);
}
const v = /* @__PURE__ */ u(m, [["render", p]]);
export {
  v as default
};
//# sourceMappingURL=thumbs-down-filled.js.map
